var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63352 4.18938C2.89979 4.18938 3.15516 4.0836 3.34344 3.89532C3.53172 3.70704 3.6375 3.45167 3.6375 3.1854C3.6375 2.91912 3.53172 2.66376 3.34344 2.47547C3.15516 2.28719 2.89979 2.18142 2.63352 2.18142C2.36724 2.18142 2.11188 2.28719 1.92359 2.47547C1.73531 2.66376 1.62954 2.91912 1.62954 3.1854C1.62954 3.45167 1.73531 3.70704 1.92359 3.89532C2.11188 4.0836 2.36724 4.18938 2.63352 4.18938ZM10.6051 5.91623C10.8461 6.15718 11 6.49184 11 6.86666C11 7.23479 10.8528 7.56945 10.6051 7.81041L7.25853 11.157C7.13438 11.2818 6.9868 11.3808 6.82427 11.4484C6.66174 11.5159 6.48745 11.5507 6.31144 11.5507C6.13542 11.5507 5.96114 11.5159 5.7986 11.4484C5.63607 11.3808 5.48849 11.2818 5.36435 11.157L0.685793 6.47846C0.438144 6.23081 0.290894 5.89615 0.290894 5.52802V2.18142C0.290894 1.43847 0.886589 0.842773 1.62954 0.842773H4.97614C5.34427 0.842773 5.67893 0.990024 5.91988 1.23098L10.6051 5.91623Z",
    fill: "#B0AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/Tags.bbb96e9c57fd99d51831f1c80c10cc07.svg";
export { ForwardRef as ReactComponent };